/**
 * @name flowHistoryFieldLabel
 * @module flowingly.runner.directives
 * @description display field labels consistently for completed steps
 * ### Notes
 * 
 * @usage
 * ```
    <flow-history-field-label field-value="{{item.text}}"></flow-history-field-label>
 * ```
 */

import angular from 'angular';
import FlowHistoryFieldLabelBridge from './FlowHistoryFieldLabelBridge';

angular
  .module('flowingly.runner.directives')
  .component('flowHistoryFieldLabel', FlowHistoryFieldLabelBridge);
